import { createAction, props, union } from '@ngrx/store';

import {
  SelectedServiceData,
  SelectionsPerTraveler,
  ServiceAvailability,
  ServiceCatalog,
  TravelerService,
} from '@fcom/dapi/interfaces/services.interface';
import { Category } from '@fcom/dapi/api/models/category';
import { FinnairCart } from '@fcom/dapi/api/models/finnair-cart';

export const startLoading = createAction('[ServicesActions] LoadStart');
export const error = createAction('[ServicesActions] LoadError');
export const setSelectionsForFragment = createAction(
  '[ServicesActions] SetSelectionsForFragment',
  props<{ category: Category; fragmentId: string; selections: SelectionsPerTraveler<TravelerService[]> }>()
);

export const setSelectionForFragmentForTraveler = createAction(
  '[ServicesActions] setSelectionForFragmentForTraveler',
  props<{
    category: Category;
    fragmentId: string;
    travelerId: string;
    selection: TravelerService | undefined;
  }>()
);

export const setCoverForId = createAction(
  '[ServicesActions] SetCoverForJourney',
  props<{ journeyId: string; travelerId: string; service: TravelerService }>()
);
export const setServiceCatalog = createAction(
  '[ServicesActions] SetServiceCatalog',
  props<{ catalog: ServiceCatalog }>()
);

export const setServiceAvailability = createAction(
  '[ServicesActions] SetServiceAvailability',
  props<{ serviceAvailability: ServiceAvailability }>()
);
export const setCampaignShown = createAction('[ServicesActions] SetCampaignShown', props<{ id: string }>());
export const setUpsell = createAction('[ServicesActions] setUpsell', props<SelectedServiceData>());
export const clearUpsell = createAction('[ServicesActions] clearUpsell');
export const reset = createAction('[ServicesActions] Reset');
export const loadServiceSelectionsFromCart = createAction(
  '[ServicesActions] LoadServiceSelectionsFromCart',
  props<{
    cartData: FinnairCart;
  }>()
);
export const removeAllPendingServices = createAction('[ServicesActions] removeAllPendingServices');

export const resetCategory = createAction('[ServicesActions] ResetCategory', props<{ category: Category }>());

export const clearAllCategories = createAction('[ServicesActions] ClearAllCategories');

const _all = union({
  startLoading,
  error,
  setCampaignShown,
  setSelectionsForFragment,
  setSelectionForFragmentForTraveler,
  setCoverForId,
  setServiceCatalog,
  setServiceAvailability,
  setUpsell,
  clearUpsell,
  reset,
  resetCategory,
  loadServiceSelectionsFromCart,
  removeAllPendingServices,
  clearAllCategories,
});

export type ActionsUnion = typeof _all;
